import { Button, Grid, Typography } from "@mui/material";
import {
  clearConvertInsertInitial,
  convertInsertConfirmedUser,
  convertInsertInitial,
} from "store/slices/convert/convertSlice";
import { useEffect, useMemo, useState } from "react";

import CompleteConvertModal from "../CompleteConvertModal";
import CountdownButton from "components/CountdownButton";
import { SpaceBetweenBox } from "components/GeneralStyled";
import useDispatch from "hooks/useDispatch";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { scrollSection } from "utils/helpers/scrollSection";
import { useTheme } from "@emotion/react";
import { actionButtonBg } from "utils/helpers/actionButtonBg";

function ConvertFooter({
  showConvertDetails,
  setShowConvertDetails,
  setRefreshHistory,
}) {
  const dispatch = useDispatch();
  const theme = useTheme()

  const [showCompleteConvertModal, setShowCompleteConvertModal] =
    useState(false);

  const [refreshButton, setRefreshButton] = useState(0);
  const [firstTime, setFirstTime] = useState(true);
  const [refreshCount, setRefreshCount] = useState(0);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const { getValues, watch, reset } = useFormContext();
  const amountTo = watch("amountTo");
  const amountFrom = watch("amountFrom");

  const convertInsert = useSelector(
    (state) => state.convert.convertInsertInitial?.data
  );

  const handleBack = () => {
    dispatch(clearConvertInsertInitial());
    setShowConvertDetails(false);
    setFirstTime(true);
    setRefreshButton(Math.random());
  };

  const handleConvertInsertInitial = async (startCountDown) => {
    try {
      setLoading(true);

      const values = getValues();

      const body = {
        coinId: values.coinId,
        coinMasterId: values.coinMasterId,
        sideId: values.sideId,
        amountFrom: values.amountFrom,
        amountTo: values.amountTo,
      };

      if (!body.amountFrom) delete body.amountFrom;
      if (!body.amountTo) delete body.amountTo;

      const {
        payload: { data },
      } = await dispatch(convertInsertInitial(body));

      setErrorMessage(data?.data?.errorMessage);
      startCountDown(data?.data?.validSeconds);
      setShowConvertDetails(true);
      setFirstTime(true);
      setRefreshCount((v) => v + 1);
    } catch (error) {}

    setLoading(false);
  };

  const handleCompleteCountdown = () => {
    setFirstTime(false);
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);

      await dispatch(convertInsertConfirmedUser({ tradeId: convertInsert.id }));
      setShowCompleteConvertModal(true);
      setRefreshButton(Math.random());
      reset();
    } catch (e) {}

    setLoading(false);
  };

  const isConfirmButtonDisabled = useMemo(
    () => !amountFrom && !amountTo,
    [amountTo, amountFrom]
  );

  useEffect(() => {
    if (refreshCount === 4) {
      setRefreshCount(0);
      setShowConvertDetails(false);
      setRefreshButton(Math.random());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCount]);

  return (
    <>
      {showConvertDetails && (
        <>
          <Grid item xs={12}>
            <SpaceBetweenBox>
              <Typography color="text.main" variant="h6">
                Price
              </Typography>

              <Typography color="text.main" textAlign="right" variant="h6">
                {convertInsert?.priceText}
              </Typography>
            </SpaceBetweenBox>

            <SpaceBetweenBox>
              <Typography color="text.main" variant="h6" maxWidth="90px">
                {convertInsert?.totalLabel}
              </Typography>

              <Typography textAlign="right" color="text.main" variant="h6">
                {convertInsert?.totalText}
              </Typography>
            </SpaceBetweenBox>

            {convertInsert?.goldTotalLabel && convertInsert?.goldTotalText ? (
              <>
                <SpaceBetweenBox>
                  <Typography color="text.main" variant="h6">
                    {convertInsert?.goldTotalLabel}
                  </Typography>

                  <Typography textAlign="right" color="text.main" variant="h6">
                    {convertInsert?.goldTotalText}
                  </Typography>
                </SpaceBetweenBox>
              </>
            ) : (
              ""
            )}
            {errorMessage && (
              <Typography color="error" variant="h6" textAlign="center">
                {errorMessage}
              </Typography>
            )}
          </Grid>

          <Grid item xs={6}>
            <Button color="info" fullWidth onClick={handleBack}>
              Back
            </Button>
          </Grid>
        </>
      )}

      <Grid item xs={showConvertDetails ? 6 : 12}>
        <CountdownButton
          variant="contained"
          color={actionButtonBg(theme)}
          fullWidth
          loading={loading}
          onClick={handleConvertInsertInitial}
          onComplete={handleCompleteCountdown}
          key={refreshButton}
          onConfirm={handleConfirm}
          disabled={isConfirmButtonDisabled || errorMessage}
          text={firstTime ? "Convert" : "Refresh"}
        />
      </Grid>

      <CompleteConvertModal
        open={showCompleteConvertModal}
        onClose={() => {
          setRefreshHistory((v) => v + 1);
          setRefreshButton(Math.random());
          scrollSection("convert_history");
          setShowConvertDetails(false);
          setShowCompleteConvertModal(false);
        }}
      />
    </>
  );
}

export default ConvertFooter;
